module.exports = __webpack_public_path__ + "static/media/product_pasta.44d1bd2f.png";